<ngx-loading-bar [color]="'#d95951'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<router-outlet  *ngIf="!applicationSettingsService.loading && applicationSettingsService.initialized"></router-outlet>
<app-page-not-found *ngIf="!applicationSettingsService.loading && !applicationSettingsService.initialized" [cannotConnectToServer]="true"></app-page-not-found>
